export default __webpack_public_path__ + "static/media/whitelogo.74db538a.svg";